import {
  Balance as ServerBalance,
  BalanceTypes,
} from 'src/types/serverTypes/Account';

export interface Balance {
  id: string;
  accountBalanceId?: string;
  currency: string;
  type: BalanceTypes;
  isDefault: boolean;
  isSubsidy: boolean;
  balance: number;
  isDisabled: boolean;
  isSMA: boolean;
  orgId?: string;
  utcLastUpdated?: string;
  lastChanged?: string;
  locationId?: string;
}
export default class BalanceBuilder {
  static build(serverBalance: ServerBalance): Balance {
    const type = serverBalance.type as BalanceTypes;
    const isDefault =
      type === BalanceTypes.Default ||
      type === BalanceTypes.Stripe ||
      type === BalanceTypes.USConnect;

    const isSubsidy =
      type === BalanceTypes.RollOver || type === BalanceTypes.TopOff;
    const isSMA = type === BalanceTypes.Sma;

    return {
      balance: serverBalance.balance,
      currency: serverBalance.currency,
      type,
      id: serverBalance.accountBalanceId,
      isDefault,
      isSubsidy,
      isSMA,
      isDisabled: serverBalance.isDisabled,
      orgId: serverBalance.orgId,
      utcLastUpdated: serverBalance.utcLastUpdated,
      locationId: serverBalance.locationId,
    };
  }
}
